/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Role_SynergistInputs */

const en_us2_exercise_role_synergist = /** @type {(inputs: Exercise_Role_SynergistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synergist`)
};

const pt_br2_exercise_role_synergist = /** @type {(inputs: Exercise_Role_SynergistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinergista`)
};

const es_419_exercise_role_synergist = /** @type {(inputs: Exercise_Role_SynergistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinergista`)
};

const pt_pt2_exercise_role_synergist = /** @type {(inputs: Exercise_Role_SynergistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinergista`)
};

const fr_fr2_exercise_role_synergist = /** @type {(inputs: Exercise_Role_SynergistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synergiste`)
};

const de_de2_exercise_role_synergist = /** @type {(inputs: Exercise_Role_SynergistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synergist`)
};

const it_it2_exercise_role_synergist = /** @type {(inputs: Exercise_Role_SynergistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinergico`)
};

/**
* | output |
* | --- |
* | "Synergist" |
*
* @param {Exercise_Role_SynergistInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_role_synergist = /** @type {((inputs?: Exercise_Role_SynergistInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Role_SynergistInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_role_synergist(inputs)
	if (locale === "es-419") return es_419_exercise_role_synergist(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_role_synergist(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_role_synergist(inputs)
	if (locale === "de-DE") return de_de2_exercise_role_synergist(inputs)
	if (locale === "it-IT") return it_it2_exercise_role_synergist(inputs)
	return en_us2_exercise_role_synergist(inputs)
});
export { exercise_role_synergist as "exercise.role_synergist" }